import NetworkIndicator from "@components/NetworkIndicator";
import { ToastConfig } from "@components/Toast";
import colors from "@constants/color";
import { fetchConfig } from "@services/firebase";
import React, { cloneElement, Component } from "react";
import { StyleSheet, Text } from "react-native";
import GlobalFont from "react-native-global-font";
import { MenuProvider } from "react-native-popup-menu";
import Toast from "react-native-toast-message";
import RootNavigation from "./navigation";

fetchConfig().catch((e) => {
  console.error(e);
});

// React 19 no longer merges `defaultProps` for forwardRef components like RN's
// Text, so the old `Text.defaultProps.allowFontScaling = false` global is
// silently ignored. Patch Text.render instead to force allowFontScaling off
// unless a caller explicitly opts in. Guarded so it patches exactly once.
if (Text.render && !Text.__allowFontScalingPatched) {
  const baseTextRender = Text.render;
  Text.render = function renderWithoutFontScaling(...args) {
    const element = baseTextRender.apply(this, args);
    return element && element.props && element.props.allowFontScaling == null
      ? cloneElement(element, { allowFontScaling: false })
      : element;
  };
  Text.__allowFontScalingPatched = true;
}

class Main extends Component {
  async componentDidMount() {
    const fontName = "NotoSansDevanagari-Regular";
    GlobalFont.applyGlobal(fontName);
  }

  render() {
    return (
      <MenuProvider customStyles={menuProviderStyles} backHandler={true}>
        <RootNavigation />
        <NetworkIndicator />
        <Toast config={ToastConfig} />
      </MenuProvider>
    );
  }
}

export default Main;

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
  },
  backdrop: {
    backgroundColor: colors.mediumBlack,
    opacity: 0.5,
  },
});

const menuProviderStyles = {
  menuProviderWrapper: styles.container,
  backdrop: styles.backdrop,
};
